export const BEST_OF = 'BEST OF';

export const STRUCTURED_CONTENT_TYPES = {
  MARKETPLACE_ENTITY_BOTTOM_LINE: 'MarketplaceEntityBottomLine',
  MARKETPLACE_ENTITY_CONS: 'MarketplaceEntityCons',
  MARKETPLACE_ENTITY_PROS: 'MarketplaceEntityPros',
  BANKING_ROUNDUP_SPOTLIGHT: 'BankingRoundupSpotlight',
  BANKING_ROUNDUP_AUTHOR_QUOTE: 'BankingRoundupAuthorQuote',
} as const;

/**
 * The default, maximum number of rows that can be present before any truncation can be applied
 * to the Roundup Summary Table.
 */
export const ROUNDUP_SUMMARY_TABLE_DEFAULT_MAX_NUM_ROWS_BEFORE_TRUNCATION = 7;
/**
 * The default, number of rows to be displayed after truncation has been applied
 * to the Roundup Summary Table.
 */
export const ROUNDUP_SUMMARY_TABLE_DEFAULT_NUM_TRUNCATED_ROWS = 5;

export const CROSS_SELL_NAMED_QUERIES = {
  SAVINGS: 'XSELL_marketing_savings',
};

export const MIN_CROSS_SELL_PRODUCT_CARDS = 2;

export const NAMED_QUERY_TO_PRODUCT_MAP = {
  [CROSS_SELL_NAMED_QUERIES.SAVINGS]: 'a savings account',
};

export const CROSS_SELL_PRODUCT_TO_PRODUCT_TEXT_MAP = {
  XSELL_PRODUCT_airline_cc: 'airline credit cards',
  XSELL_PRODUCT_balance_transfer_cc: 'balance transfer credit cards',
  XSELL_PRODUCT_business_cc: 'business credit cards',
  XSELL_PRODUCT_cash_back_cc: 'cash back credit cards',
  XSELL_PRODUCT_cc: 'credit cards',
  XSELL_PRODUCT_cd: 'CDs',
  XSELL_PRODUCT_checking_account: 'checking accounts',
  XSELL_PRODUCT_low_interest_cc: 'low interest credit cards',
  XSELL_PRODUCT_mortgage_lender: 'mortgage lenders',
  XSELL_PRODUCT_no_annual_fee_cc: 'no annual fee credit cards',
  XSELL_PRODUCT_personal_loan: 'personal loans',
  XSELL_PRODUCT_rewards_cc: 'rewards credit cards',
  XSELL_PRODUCT_secured_cc: 'secured credit cards',
  XSELL_PRODUCT_student_cc: 'student credit cards',
  XSELL_PRODUCT_student_loan: 'student loans',
  XSELL_PRODUCT_travel_cc: 'travel credit cards',
};

export enum RoundupSummaryListQuickFactsEnum {
  Apy = 'apy',
  Bonus = 'bonus',
  Default = 'default',
  MinimumBalance = 'minimum_balance',
  MonthlyFee = 'monthly_fee',
  OutOfNetworkAtmFee = 'out_of_network_atm_fee',
}

// Taken from https://github.com/NerdWallet/query0/blob/e0e16561295b96d57e60a633e00d4aa0d2875612/src/schema/wp/extensions/roundup/utils/Roundup.js#L551
const getCrossSellSubtext = (recommendedCategoryText: string, crossSellProduct?: string) => {
  const currentProductText = crossSellProduct
    ? CROSS_SELL_PRODUCT_TO_PRODUCT_TEXT_MAP[
        crossSellProduct as keyof typeof CROSS_SELL_PRODUCT_TO_PRODUCT_TEXT_MAP
      ]
    : null;

  let subText = '';
  if (currentProductText && recommendedCategoryText) {
    subText = `People who search for ${currentProductText} often identify opening ${recommendedCategoryText} as their next money move.`;
  } else if (recommendedCategoryText) {
    subText = `People often identify opening ${recommendedCategoryText} as their next money move.`;
  }
  return subText;
};

export const getCrossSellSubtextFromNamedQuery = (
  namedQuery: string,
  crossSellProduct?: string,
) => {
  const namedQueryText = NAMED_QUERY_TO_PRODUCT_MAP[namedQuery];
  return getCrossSellSubtext(namedQueryText, crossSellProduct);
};
